module.exports = function getResource(label, vars = []) {
    const resources = {
        beautyPreferencesTitle: 'Préférences beauté',
        beautyPreferencesDesc: 'Dites-nous vos traits de beauté et vos préférences d’achat pour obtenir des recommandations plus personnalisées.',
        profileCompletionStatusHeading: 'Complétez vos préférences de beauté',
        profileCompleteMessageHeading: 'Merci d’avoir partagé vos préférences. Vous avez débloqué des recommandations personnalisées.',
        checkRecommendationsLinkHeading: 'Consultez vos recommandations de produits.',
        profileInterimMessageHeading: 'Continuez! Plus vous nous en dites, plus les recommandations seront efficaces.',
        save: 'Sauvegarder',
        saveAndContinue: 'Enregistrer et continuer',
        skipThisQues: 'Ignorer cette question',
        signIn: 'Ouvrir une session pour enregistrer',
        confettiModalTitle: 'Continue!',
        confettiModalMessage: 'Continuez! Plus vous nous en direz, meilleures seront les recommandations.',
        confettiModalButton: 'Compris',
        confettiModalMessageComplete: 'Félicitations! Vos préférences beauté sont complètes.',
        privacySettings: 'Paramètres de confidentialité des préférences beauté'
    };
    return resources[label];
};
